import { fetchToken } from '@agissc/ktag-map';
import { useQuery } from '@tanstack/react-query';
import { LegendProps, MapServerLegends } from './Contracts';

const fetchTopicLegend = async (topicLayerUrl: string, isPublic: boolean) => {
  const headers = new Headers();

  if (!isPublic) {
    const token = await fetchToken();
    headers.set('Authorization', `Bearer ${token}`);
  }

  const requestApi = new Request(`${topicLayerUrl}/legend?f=json`, { headers });
  const response = await fetch(requestApi);
  const data: MapServerLegends = await response.json();

  const result = data.layers.reduce<Record<number, LegendProps[]>>((acc, item) => {
    acc[item.layerId] = item.legend ?? [];
    return acc;
  }, {});

  return result;
};

export const useLegendQuery = (topicLayerUrl: string, isPublic: boolean) => {
  return useQuery<Record<number, LegendProps[]>>({
    queryKey: ['topicLegend', topicLayerUrl],
    queryFn: () => fetchTopicLegend(topicLayerUrl, isPublic),
    gcTime: 3600000,
    staleTime: Infinity,
  });
};
